// extracted by mini-css-extract-plugin
export default {"flexContainer":"StaffCalendar_flexContainer__oA7Kr"};